module.exports = __webpack_public_path__ + "static/media/no_travel.eea2b0f1a6ee4efd2b0fd0469a7532a3.svg";